import { formatFullName } from 'platform/shared/health-apps';

/**
 * Map state values to create selector for PDF download properties
 * @param {Object} state - the current state values
 * @returns {Object} - PDF download properties to use in components
 */
export const selectPdfDownload = state => {
  const { veteranFullName } = state.form?.data ?? {};
  return { fullName: formatFullName(veteranFullName) };
};
